var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { createContext, useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { useWebsocket } from '~/providers/websocket';
import { setComparisonDocuments, setDocumentComparisonId, } from '~/redux/reducers/states/comparison_documents';
import { getComparisonDocumentsById } from './queries';
const DocumentComparisonContext = createContext({});
const DocumentComparisonProvider = (props) => {
    const dispatch = useDispatch();
    const ws = useWebsocket();
    const { id: documentComparisonId } = useParams();
    const { documentComparisonId: reduxDocumentComparisonId, comparisonDocuments, } = useSelector((state) => state.comparisonDocumentsState);
    const [anchorDocId, setAnchorDocId] = useState();
    useEffect(() => {
        const fetchComparisonDocs = (docCompareId) => __awaiter(void 0, void 0, void 0, function* () {
            const compareDocs = yield getComparisonDocumentsById(docCompareId, ws);
            dispatch(setComparisonDocuments(compareDocs));
            if (anchorDocId === undefined)
                setAnchorDocId(compareDocs[0].documentComparisonFileId);
            dispatch(setDocumentComparisonId(documentComparisonId));
        });
        if (reduxDocumentComparisonId !== documentComparisonId) {
            fetchComparisonDocs(documentComparisonId);
        }
        else {
            if (anchorDocId === undefined) {
                setAnchorDocId(comparisonDocuments[0].documentComparisonFileId);
            }
        }
    }, [documentComparisonId]);
    const value = {
        comparisonDocuments,
        anchorDocId,
        setAnchorDocId,
    };
    return React.createElement(DocumentComparisonContext.Provider, Object.assign({ value: value }, props));
};
const useDocumentComparison = () => {
    const ctx = useContext(DocumentComparisonContext);
    if (ctx === undefined) {
        throw new Error('DocumentComparisonContext can only be used under the DocumentComparisonProvider');
    }
    return ctx;
};
export { useDocumentComparison, DocumentComparisonProvider, };
